import { GiftItemType } from './itemTypes'

export enum GiftCardStatus {
  // Do not reorder these, as the order here is used in the Sales table drop down
  Paid = 'paid',
  Delivered = 'delivered',
  Redeemed = 'redeemed',
  Expired = 'expired',
  Cancelled = 'cancelled',
  Booked = 'booked',
}

export enum DeliverTo {
  Purchaser = 'purchaser',
  Recipient = 'recipient',
}

export enum DeliveryFormat {
  Email = 'email',
  Post = 'post',
  Print = 'print',
}

export interface IGiftCardResponse {
  id: string
  orderId: number
  purchaseTimestamp: number
  startDate: number
  expiryDate: number
  value: number
  code: string
  message: string
  purchaserEmail: string
  purchaserTitle: string
  purchaserFirstName: string
  purchaserLastName: string
  purchaserPhone: string
  purchaseDate: number
  deliverTo: DeliverTo
  deliveryFormat: DeliveryFormat
  deliveryTitle: string
  deliveryFirstName: string
  deliveryLastName: string
  deliveryEmail: string
  deliveryAddressLineOne: string
  deliveryAddressLineTwo: string
  deliveryAddressTown: string
  deliveryAddressCounty: string
  deliveryAddressPostcode: string
  deliveryDate: number
  status: GiftCardStatus
  manualPaymentReference: string
  giftItemName: string
  giftItemStart: string
  giftItemDetails: string
  giftItemTerms: string
  giftItemCompanyTerms: string
  redeemDate: number
  redeemUser: string
  quantity: string
  cancelDate: string
  cancelUser: string
  cancelReason: string
  giftItemRestrictions: string
  extensionReason: string
  extensionUser: string
  startInfo: string
  originalPrice: number
  pdfUrl: string
  dispatchedDate?: number
  manualUser?: string
  paymentReference?: string
  notes?: string
  priceName?: string
  organisationId?: number
  type: GiftItemType
  redemptionValue?: number
  redemptionHistory?: {
    id: number
    value: number
    redemptionValue: number
    redemptionDate: number
  }[]
}
